export class WetSandTracker {
  private wetness: Float32Array;
  private width: number;
  private height: number;
  private dryRate: number = 0.05; // How fast sand dries per frame

  constructor(width: number, height: number) {
    this.width = width;
    this.height = height;
    this.wetness = new Float32Array(width * height);
  }

  private getIndex(x: number, y: number): number {
    return y * this.width + x;
  }

  public update(waterGrid: any, sandGrid: any, deltaTime: number): void {
    // Decay wetness over time (sand dries)
    for (let i = 0; i < this.wetness.length; i++) {
      this.wetness[i] = Math.max(0, this.wetness[i] - this.dryRate * deltaTime);
    }

    // Mark cells as wet where water is present above sand
    // Water depth is stored as relative height (depth above sand)
    for (let y = 0; y < this.height; y++) {
      for (let x = 0; x < this.width; x++) {
        const waterDepth = waterGrid.getHeight(x, y);
        const sandHeight = sandGrid.get(x, y);

        // If there's water above the sand, mark it as wet
        if (waterDepth > 0.1 && sandHeight > -1) {
          const idx = this.getIndex(x, y);
          this.wetness[idx] = Math.min(1.0, this.wetness[idx] + deltaTime * 2);
        }
      }
    }
  }

  public getWetness(x: number, y: number): number {
    if (x < 0 || x >= this.width || y < 0 || y >= this.height) return 0;
    return this.wetness[this.getIndex(x, y)];
  }

  public clear(): void {
    this.wetness.fill(0);
  }
}
